import { render, staticRenderFns } from "./PricingDetailsComponent.vue?vue&type=template&id=f5d1f17e&scoped=true"
import script from "./PricingDetailsComponent.vue?vue&type=script&lang=js"
export * from "./PricingDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./PricingDetailsComponent.vue?vue&type=style&index=0&id=f5d1f17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d1f17e",
  null
  
)

export default component.exports